/**
  * Builds a view for interacting with setting a product content license to active or inactive.
  *
  * Usage:
  *
  *   data-sw-product-content-license=<spin string>
  *   data-sw-product-content-license=<id int>
  *
  */
 
var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-product-content-license]').each(function() {
    var $el = $(this);

    require(['js/lib/views/ProductContentLicense', 'js/lib/models/ModelManager'], function(ProductContentLicense, ModelManager) {
      var spin = $el.data('swProductContentLicense');

      new ProductContentLicense({
        model:  ModelManager.getProductEdit(spin),
        el:     $el
      });
    });
  });
};
